import React from "react";

const Pagination = ({ pagination, postsPerPage, handlePageSizeChange, fetchDetail }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      {/* Left: Page size dropdown */}
      <div className="col-md-3 d-flex align-items-center">
        <label>
          <select
            name="entries"
            className="form-control form-control-sm"
            value={postsPerPage}
            onChange={handlePageSizeChange}
          >
            <option value={5}>5 / page</option>
            <option value={10}>10 / page</option>
            <option value={20}>20 / page</option>
            <option value={50}>50 / page</option>
            <option value={100}>100 / page</option>
          </select>
        </label>
      </div>

      {/* Right: Numbered Pagination */}
      <nav aria-label="Page navigation" style={{paddingRight:10,paddingBottom:10}}>
        <ul className="pagination mb-0">
          {/* Previous */}
          <li className={`page-item ${pagination?.page === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => fetchDetail(pagination?.page - 1, postsPerPage)}
            >
              &laquo;
            </button>
          </li>

          {/* Numbered pages with ellipsis */}
          {Array.from({ length: pagination?.total_pages }, (_, i) => i + 1).map(
            (num) => {
              if (
                num === 1 ||
                num === pagination?.total_pages ||
                (num >= pagination?.page - 2 && num <= pagination?.page + 2)
              ) {
                return (
                  <li
                    key={num}
                    className={`page-item ${num === pagination?.page ? "active" : ""}`}
                  >
                    <button
                      className="page-link"
                      onClick={() => fetchDetail(num, postsPerPage)}
                    >
                      {num}
                    </button>
                  </li>
                );
              } else if (num === pagination?.page - 3 || num === pagination?.page + 3) {
                return (
                  <li key={num} className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                );
              } else {
                return null;
              }
            }
          )}

          {/* Next */}
          <li
            className={`page-item ${pagination?.page === pagination?.total_pages ? "disabled" : ""}`}
          >
            <button
              className="page-link"
              onClick={() => fetchDetail(pagination?.page + 1, postsPerPage)}
            >
              &raquo;
            </button>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Pagination;
